export default __webpack_public_path__ + "static/media/dashboad-icon-grey.904025ef.svg";